import ExtraFieldsList from '@web/components/page-components/ExtraFields'
import { ExtraField } from '@web/graphql-types'
import { useEffect } from 'react'
import { useDonationFormContext } from '../../DonationFormProvider'
import { PageProfileSelectorProps } from './ProfileSelector'

type DonationFormExtraFieldsProps = {
  fields: ExtraField[]
  Components: {
    ProfileSelector: React.FC<PageProfileSelectorProps>
  }
}

const ExtraFields = ({ fields, Components }: DonationFormExtraFieldsProps) => {
  const formValues = useDonationFormContext((state) => state.formValues)
  const googleMapsApiKey = useDonationFormContext((state) => state.googleMapsApiKey)
  const setFormValues = useDonationFormContext((state) => state.actions.setFormValues)
  const isThreeStepForm = useDonationFormContext((state) => state.settings.styles?.steps === 3)

  const onChange = (name: string, value: string) => {
    setFormValues({ extraFields: { [name]: value } })
  }

  useEffect(() => {
    fields.forEach((field) => {
      if (field.customField && !formValues.extraFields?.[field.customField.id]) {
        onChange(field.customField.id, field.defaultValue ?? '')
        return
      }

      if (!formValues.extraFields?.[field.name]) {
        onChange(field.name, field.defaultValue ?? '')
      }
    })
  }, [fields])

  return (
    <ExtraFieldsList
      fields={fields}
      values={formValues.extraFields}
      onChange={onChange}
      googleMapsApiKey={googleMapsApiKey}
      address={formValues.address}
      onAddressChange={(address) => setFormValues({ address })}
      includeProfileFields={isThreeStepForm}
      Components={Components}
    />
  )
}

export default ExtraFields
